<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Input</h1>
  </div>
</div>

<div class="form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-input
          formControlName="firstName"
          [label]="'First name'">
        </ui-platform-input>
      </div>
      <div class="col-6 ui-platform-form-control">
        <ui-platform-input
          formControlName="lastName"
          [label]="'Last name'">
        </ui-platform-input>
      </div>
      <div class="col-6 ui-platform-form-control">
        <ui-platform-input
          formControlName="middleName"
          [label]="'Middle name'">
        </ui-platform-input>
        <div
          class="ui-platform-form-control-error"
          *ngIf="middleNameError">
          Required
        </div>
      </div>
      <div class="col-6 ui-platform-form-control">
        <ui-platform-input
          formControlName="familyName"
          [label]="'Family name'"
          [placeholder]="'Enter text...'">
        </ui-platform-input>
      </div>
    </div>
  </form>
</div>

<div class="row">
  <div class="col-8">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
    <p><i>Note: display of errors in not part of a component, implemented as ui-platform-form-control classes</i></p>
  </div>
</div>
